/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BulkUpdateMonthlyUsageLimit200ResponseInnerReissueOneOf
 */
export interface BulkUpdateMonthlyUsageLimit200ResponseInnerReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerReissueOneOf
     */
    'cardType': BulkUpdateMonthlyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerReissueOneOf
     */
    'expiredDate': string;
}

export const BulkUpdateMonthlyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type BulkUpdateMonthlyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum = typeof BulkUpdateMonthlyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum[keyof typeof BulkUpdateMonthlyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum];


